import { Box, Chip, Typography } from "@mui/material";
import { IconButton } from "@mui/material";
import { LinkCore } from "src/Pages/components/LinkCore/LinkCore";
import { UrlConfig } from "src/shared/Utils/paths";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { SearchIcon, AddTaskIcon } from "src/Pages/components/Icons/Icons";
import { ArrowForwardIcon } from "src/Pages/components/Icons/Icons";
import FileUploadIcon from '@mui/icons-material/FileUpload';
import { useContextParcelas } from "src/Contexts/Parcelas/ParcelasContext";
import { valuesDefaultUploadImportInstallments } from "src/Contexts/Parcelas/valuesDefaultInputsParcelas/ValueDefaultInputParcelas";

interface IHeaderInstallment {
  step: number;
  setStep: (step: number) => void;
}

export const HeaderInstallment = ({ step, setStep }: IHeaderInstallment) => {
  const { setFilesUploadImportInstallments } = useContextParcelas();

  const clearUpload = () => {
    setFilesUploadImportInstallments(valuesDefaultUploadImportInstallments);
  }

  return (
    <Box sx={{ display: "flex", justifyContent: "space-between", gap: 2, mb: 4 }}>
      <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
        {step === 1 && (
          <LinkCore to={UrlConfig.lancamentos.parcelas.url} onClick={clearUpload}>
            <IconButton aria-label="back" >
              <ArrowBackIcon />
            </IconButton>
          </LinkCore>
        )}

        {step > 1 && (
          <IconButton aria-label="back" onClick={() => {
            setStep(step - 1);
            clearUpload();
          }}>
            <ArrowBackIcon />
          </IconButton>
        )}

        <Box>
          <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            <Typography variant="h6">
              Importação de parcelas
            </Typography>
            <Chip
              label="Novo"
              size="small"
              color="primary"
              variant="outlined"
              sx={{ height: "24px", fontSize: "0.7rem", fontWeight: 600 }}
            />
          </Box>
          <Typography variant="body1">
            Faça upload do arquivo para análise e baixa de parcelas
          </Typography>
        </Box>
      </Box>

      <Box sx={{ display: "flex", alignItems: "center", gap: 1.5, mr: 3 }}>
        <Chip
          icon={<FileUploadIcon />}
          label="Upload"
          size="small"
          color="primary"
          variant={step === 1 ? undefined : "outlined"}
          sx={{ height: "28px", fontSize: "0.9rem", fontWeight: 600, padding: "4px 12px" }}
        />
        <ArrowForwardIcon fontSize="inherit" />
        <Chip
          icon={<SearchIcon />}
          label="Análise"
          size="small"
          color="primary"
          variant={step === 2 ? undefined : "outlined"}
          sx={{ height: "28px", fontSize: "0.9rem", fontWeight: 600, padding: "4px 12px" }}
        />
        <ArrowForwardIcon fontSize="inherit" />
        <Chip
          icon={<AddTaskIcon />}
          label="Confirmar"
          size="small"
          color="primary"
          variant={step === 3 ? undefined : "outlined"}
          sx={{ height: "28px", fontSize: "0.9rem", fontWeight: 600, padding: "4px 12px" }}
        />
      </Box>
    </Box>
  );
};